function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("path", {
  id: "b",
  d: "M22 55.354H7.24A6.24 6.24 0 0 1 1 49.114V23.932a6.24 6.24 0 0 1 6.24-6.24h9.452V12.14c0-5.6 4.54-10.14 10.14-10.14h4.828c5.6 0 10.14 4.54 10.14 10.14v5.552h23.538V12.14c0-5.6 4.54-10.14 10.14-10.14h4.828c5.6 0 10.14 4.54 10.14 10.14v5.552h6.314a6.24 6.24 0 0 1 6.24 6.24v25.182a6.24 6.24 0 0 1-6.24 6.24H82V91h3.88A3.12 3.12 0 0 1 89 94.12v6.76a3.12 3.12 0 0 1-3.12 3.12H67.12a3.12 3.12 0 0 1-3.12-3.12v-6.76A3.12 3.12 0 0 1 67.12 91H71V55.354H33V91h3.88A3.12 3.12 0 0 1 40 94.12v6.76a3.12 3.12 0 0 1-3.12 3.12H18.12a3.12 3.12 0 0 1-3.12-3.12v-6.76A3.12 3.12 0 0 1 18.12 91H22V55.354z"
}), React.createElement("filter", {
  id: "a",
  width: "103.9%",
  height: "103.9%",
  x: "-1%",
  y: "-1%",
  filterUnits: "objectBoundingBox"
}, React.createElement("feOffset", {
  dx: 2,
  dy: 2,
  in: "SourceAlpha",
  result: "shadowOffsetOuter1"
}), React.createElement("feColorMatrix", {
  in: "shadowOffsetOuter1",
  values: "0 0 0 0 0.439215686 0 0 0 0 0.439215686 0 0 0 0 0.439215686 0 0 0 0.157260708 0"
})), React.createElement("path", {
  id: "c",
  d: "M10.14 0h4.828c5.6 0 10.14 4.54 10.14 10.14v7.122H0V10.14C0 4.54 4.54 0 10.14 0z"
}));

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("use", {
  fill: "#000",
  filter: "url(#a)",
  xlinkHref: "#b"
}), React.createElement("use", {
  fill: "#FFF",
  xlinkHref: "#b"
}), React.createElement("g", {
  transform: "translate(1 2)"
}, React.createElement("path", {
  fill: "#707070",
  d: "M74.478 0h4.828c5.6 0 10.14 4.54 10.14 10.14v7.122H64.338V10.14c0-5.6 4.54-10.14 10.14-10.14z",
  opacity: 0.05
}), React.createElement("path", {
  fill: "#9F9F9F",
  d: "M64.338 17.822V9.976l25.108 3.923v3.923zM70 85V60.846L81 57v28z",
  opacity: 0.147
}), React.createElement("rect", {
  width: 25,
  height: 13,
  x: 63,
  y: 89,
  fill: "#707070",
  opacity: 0.05,
  rx: 3.12
}), React.createElement("path", {
  fill: "#707070",
  d: "M70 53v8l11-4v-4zM81 89v-4H70v4z",
  opacity: 0.05
}), React.createElement("path", {
  fill: "#9F9F9F",
  d: "M21 85l.38-24.154L32 56.923V85z",
  opacity: 0.147
}), React.createElement("rect", {
  width: 25,
  height: 13,
  x: 14,
  y: 89,
  fill: "#707070",
  opacity: 0.05,
  rx: 3.12
}), React.createElement("path", {
  fill: "#707070",
  d: "M21 53v8l11-4v-4zM32 89v-4H21v4z",
  opacity: 0.05
}), React.createElement("g", {
  transform: "translate(15.692)"
}, React.createElement("mask", {
  id: "d",
  fill: "#fff"
}, React.createElement("use", {
  xlinkHref: "#c"
})), React.createElement("use", {
  fill: "#707070",
  opacity: 0.05,
  xlinkHref: "#c"
}), React.createElement("path", {
  fill: "#9F9F9F",
  d: "M8.35.078h8.407l-4.203 25.736H8.35z",
  mask: "url(#d)",
  opacity: 0.147,
  transform: "rotate(-90 12.554 12.946)"
})), React.createElement("path", {
  fill: "#9F9F9F",
  fillOpacity: 0.503,
  stroke: "#F8F8F8",
  strokeWidth: 6.24,
  d: "M6.24 18.812a3.12 3.12 0 0 0-3.12 3.12v25.182a3.12 3.12 0 0 0 3.12 3.12h89.52a3.12 3.12 0 0 0 3.12-3.12V21.932a3.12 3.12 0 0 0-3.12-3.12H6.24z"
}), React.createElement("path", {
  fill: "#FFF",
  d: "M87.223 21.97h6.93l-13.86 25.107h-6.931zM66.43 21.97h6.932L59.5 47.076h-6.93zM45.638 21.97h6.931L38.708 47.076h-6.931zM24.846 21.97h6.93l-13.86 25.107h-6.931z"
})));

var SvgIcError = function SvgIcError(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 104,
    height: 104,
    viewBox: "0 0 104 104",
    ref: svgRef
  }, props), _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgIcError, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ic_error.ebdb86c5.svg";
export { ForwardRef as ReactComponent };